import {
	isIntentDetectionSuccess,
	jiraIntentDetectionQuery,
} from '@atlassian/search-client/intent-detection';
import {
	KnowledgeDiscoveryJiraSearchExperience,
	type JiraIntentDetectionQueryVariables,
} from '@atlassian/search-client/knowledge-discovery/types';

import { INTENT_TYPE } from '../constants';
import { type IntentPattern, type IntentResponse } from '../types';

export type JiraRemoteIntentOptions = Pick<
	JiraIntentDetectionQueryVariables,
	'siteId' | 'orgId' | 'sessionId' | 'model'
> & {
	headers?: Record<string, string>;
};

const knownIntentPatterns: readonly IntentPattern[] = [
	'EMPTY',
	'JQL',
	'NUMERIC',
	'QUESTION',
	'SINGLE_WORD',
	'NO_PATTERN',
];

const toIntentPattern = (pattern: string | null | undefined): IntentPattern =>
	knownIntentPatterns.includes(pattern as IntentPattern)
		? (pattern as IntentPattern)
		: 'NO_PATTERN';

/** Adapts the Jira Knowledge Discovery service to the intent harness response. */
export const getInputIntentRemoteJira = async (
	input: string,
	options: JiraRemoteIntentOptions,
): Promise<IntentResponse> => {
	const response = await jiraIntentDetectionQuery(
		{
			query: input,
			siteId: options.siteId,
			orgId: options.orgId,
			sessionId: options.sessionId,
			experience: KnowledgeDiscoveryJiraSearchExperience.QUICK_FIND,
			model: options.model,
			includePatternType: true,
		},
		options.headers,
	);
	const result = response.data?.knowledgeDiscovery.jiraIntentDetection;

	if (!isIntentDetectionSuccess(result)) {
		throw new Error('Jira intent detection returned an unsuccessful response');
	}

	const classification = result.searchClassification;

	return {
		didMatch: classification.type !== null && classification.type !== undefined,
		type: classification.type ?? INTENT_TYPE.FPS,
		pattern: toIntentPattern(classification.pattern),
	};
};
